import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import Foundry from './js/Foundry';

ReactDOM.render(<Foundry />, document.getElementById('foundry'));
